const RecentActivity = ({ systemStatus = {}, recentData = [] }) => {
  // ✅ Convert API ka points_status object into array
  const systemStatusItems = Object.keys(systemStatus).map((key) => ({
    name: key,
    active: systemStatus[key]?.active || 0,
    closed: systemStatus[key]?.closed || 0,
  }));

  // ✅ Recent activity data already array me aa raha hai
  const recentActivityItems = recentData.map((item) => ({
    type: item.lost_or_found || "update", // ya jo bhi logic lagana ho
    title: item.name || "System update",
    description: item.description || "",
    time: new Date(item.entry_date).toLocaleTimeString(), // entry_date ko readable time me convert
  }));

  return (
    <div className="recent-activity-container">
      {/* 🟢 Points Status */}
      <div className="recent-activity-panel system-status">
        <h2 className="panel-title">Points Status</h2>
        <div className="status-list">
          {systemStatusItems.map((item, index) => (
            <div key={index} className="status-item">
              <span className="status-name">{item.name}</span>
              <div className="statusConut">
                <span className="status-badge active">
                  Active - {item.active}
                </span>
                <span className="status-badge closed">
                  Closed - {item.closed}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 🕑 Recent Activity */}
      <div className="recent-activity-panel recent-activity">
        <h2 className="panel-title">Recent Activity</h2>
        <div className="activity-list">
          {recentActivityItems.length > 0 ? (
            recentActivityItems.map((item, index) => (
              <div key={index} className="activity-item">
                <div className={`activity-indicator ${item.type}`}></div>
                <div className="activity-content">
                  <div>
                    <div className="activity-title">{item.title}</div>
                    <div className="activity-description">
                      {item.description}
                    </div>
                  </div>
                  <div className="activity-time">{item.time}</div>
                </div>
              </div>
            ))
          ) : (
            <p>No recent activity</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;
